// extracted by mini-css-extract-plugin
export default {"panel-view":"EMwuCVQ7mz","panelView":"EMwuCVQ7mz","menu":"VIi8u29sil","panel-view-menu-item":"OZTVF_m9Vi","panelViewMenuItem":"OZTVF_m9Vi","link":"VUAus0HfAo","active":"I7nUpWKyvO"};